import Link from 'next/link';

// Component
import PriceContainer from 'components/PriceContainer';
import CourseOrganizerImage from '../CourseOrganizerImage';
import { getClassNameByLang } from 'utils/getClassByLang';
import Button from 'components/Button';
import { BUTTON_TYPE } from 'constants/button';
import { Heading, SubHeading, TextBody } from 'components/Typography/General';
import { FONT_TYPES } from 'variables/font_groups';
import { isMobile } from 'react-device-detect';
import { getDirectionByLanguage } from 'utils/get_direction';
import { stripHTML } from 'utils/helper';
import { trackCtaClick, trackSelectContent } from 'lib/analytics';

const RecommendedCourses = (props) => {
  const { itemId, picture, courseOrganizer, courseTitle, description, discount, price, courseSlug, language } = props;

  const classNameByLang = getClassNameByLang(language);

  return (
    <div className="card-horizontal description-recomended">
      <div className="course-image-container">
        <img src={picture ? picture : '/dummy-img-card.jpeg'} className="course-image" alt="course image"></img>
      </div>
      <div className="description-recomended__details">
        <div>
          <CourseOrganizerImage courseOrganizer={courseOrganizer} />
          <SubHeading variety={3} dir={getDirectionByLanguage(language)} className={`title-2 ${classNameByLang}`}>
            {courseTitle}
          </SubHeading>
        </div>
        <TextBody variety={4} dir={getDirectionByLanguage(language)} className={`description ${classNameByLang}`}>
          {stripHTML(description)}
        </TextBody>
        <div className="informations">
          <div className="author">
            <TextBody variety={4}>{courseOrganizer?.name}</TextBody>
          </div>
          {/* if discount not available or 0, show the real price. Else, show the discounted price with the actual price */}
          <PriceContainer
            variableDiscount={[parseFloat(discount)]}
            variablePrice={[parseFloat(price)]}
            courseOrganizer={courseOrganizer.code}
            isLarge
          />
        </div>
      </div>
      <Link href={`/courses/${courseSlug}`}>
        <Button
          type={BUTTON_TYPE.secondary}
          variety={isMobile ? 3 : 4}
          fontType={FONT_TYPES.textBody}
          className="button-information"
          onClick={() => {
            trackSelectContent({
              page_type: 'course_detail',
              item_id: itemId,
              item_name: courseTitle,
              item_category: courseOrganizer?.name || 'unknown',
              list_name: 'courses',
            });
            trackCtaClick({
              page_type: 'course_detail',
              cta_label: 'open_course_detail',
              location: 'recommended_courses_section',
              course_id: itemId,
            });
          }}
        >
          More Information
        </Button>
      </Link>
    </div>
  );
};

export default RecommendedCourses;
